export class Controller {

    /** @ngInject */
    constructor(UsersResource) {
        this.UsersResource = UsersResource;
    }

    $onInit() {
    }

    delete() {
        const {companyId, companyUserId} = this.resolve;

        this.isSaving = true;
        this.UsersResource
            .deleteCompanyUser(companyId, companyUserId)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/delete-user/delete-user.controller.js